var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full rounded-tr-4xl rounded-br-4xl"})
}
var staticRenderFns = []

export { render, staticRenderFns }